import {
  differenceInDays,
  differenceInMonths,
  differenceInYears,
  format,
  isValid
} from "date-fns";
import th from "date-fns/locale/th";

export const renderDateString = (
  dateStr?: string,
  formatStr?: string
): string => {
  if (!dateStr || dateStr.length === 0) return "";

  const date = new Date(dateStr);
  if (!isValid(date)) return "";

  return format(date, formatStr ?? "dd MMMM yyyy", { locale: th });
};

export const renderDateTimeString = (dateStr?: string): string => {
  if (!dateStr || dateStr.length === 0) return "";

  const date = new Date(dateStr);
  if (!isValid(date)) return "";

  return format(date, "dd MMMM yyyy HH:mm:ss", { locale: th });
};

export const renderFullAge = (dateStr: string) => {
  if (!dateStr || dateStr.length === 0) return "";

  const date = new Date(dateStr);
  if (!isValid(date)) return "";
  const now = new Date();

  const year = differenceInYears(now, date);
  const month = +differenceInMonths(now, date) % 12;
  const day = +differenceInDays(now, date) % 30;

  return `${year} ปี  ${month} เดือน  ${day} วัน`;
};
